import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SocialLink } from '@bd/bdcore-utilities';
import links from './MenuLinks';
import OSCTagMobile from './OSCTagMobile';
import { colors, typography } from '../styles';

const styles = css`
  display: block;
  clear: both;
  background-image: url('/images/footer-bg.jpg');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  padding: 75px 0 60px 0;
  margin: 0;
  @media (min-width: 992px) {
    padding: 70px 0 90px 0;
    margin: 0;
  }
  .HeadingTitle_small{
    display: block;
    width: 100%;
    font-family:${typography.Serif};
    font-weight: 600;
    font-style: italic;
    text-align: center;
    font-size: 18px;
    color: ${colors.color2};
    text-align: center;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .HeadingTitle_large{
    display: block;
    width: 100%;
    text-align:center;
    font-family:${typography.SansSerif};
    text-transform: uppercase;
    font-size: 40px;
    letter-spacing: 0;
    text-align: center;
    line-height: 1.2;
    color: ${colors.color1};
    font-weight: 200;
    @media (min-width: 993px) {
      font-size: 60px;
    }
  }

  .Footer_menu {
    display: none;
    @media (min-width: 992px) {
      display: flex;
      padding: 50px 0;
      margin: 0;
      justify-content: top;
      list-style: none;
      text-align: left;
    }
  }
  .Footer_menuHeader {
    display: block;
    font-family:${typography.Serif};
    font-weight: 700;
    text-transform: uppercase;
    font-size: 16px;
    letter-spacing: 1px;
    color: ${colors.color1};
    vertical-align: top;
    &:after {
      content: '';
      display: block;
      width: 55px;
      height: 2px;
      background-color ${colors.color2Light};
      margin: 9px auto;
    }
  }
  .Footer_menuItem {
    width: 33%;
    text-align: center;

  }
  .Footer_menuLink, a {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.color1};
    line-height: 18px;
    &:hover {
      text-decoration: none;
      color: ${colors.color1Light};
    }
  }
  .Footer_contactInfo {
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    padding: 0 15px;
    display: block;
    color: ${colors.color1};
    @media (min-width: 992px) {
      display: block;
      text-align: center;
    }
  }
  .FooterBottom {
    padding: 0 0 30px 0;
  }
  .Footer_EHOLogo {
    display: block;
    height: 22px;
    width: 40px;
    margin: 0 auto 10px auto;

    @media (min-width: 992px) {
      height: 18px;
      width: auto;
    }
  }
  .Copyright {
    text-align: center;
    display: block;
    color: ${colors.color1};
    font-size: 16px;
    font-weight: 500;
    margin: 0 auto 10px auto;
    @media (min-width: 992px) {

    }
  }
  .SiteBy {
    display: block;
    color: ${colors.color1};
    font-size: 12px;
    font-weight: 500;
    margin: 0 auto 10px auto;
    text-align: center;
    @media (min-width: 992px) {
    }
     a{
       color: ${colors.color1};
     }
  }
  .BuilderName {
    color: ${colors.color1};
    font-weight: 700;
  }
  .Footer_socialLinks {
    padding: 0;
    margin: 0 auot;
    text-align: center;
    li {
      display: inline-block;
      margin: 0 5px 0 5px;
      @media (min-width: 992px) {
        margin: 0 20px 0 0;
      }
      a img {
        height: 18px;
        width: auto;
        filter: brightness(100%);
      }
    }
    @media (min-width: 992px) {
      text-align: center;
      margin: 0;
      li {
        display: inline-block;
        margin: 0 10px;
      }
    }
  }

`;

function Footer({ agent, builder }) {
  // if every link in the group is marked as `footer: false`, exclude that entire group
  const footerLinkGroups = links.filter(menuGroup => {
    const footerLink = menuGroup.menuItems.find(link => get(link, 'footer') !== false);
    return !!footerLink;
  });
  return (
    <footer className={styles}>
      <div className="FooterMenu">
        <div className="container">
          <nav>
            <ul className="Footer_menu list-unstyled">
              {
                footerLinkGroups.map(group => (
                  <li className="Footer_menuItem" key={group._id}>
                    <span className="Footer_menuHeader">{group.menuName}</span>
                    <ul className="Footer_subMenu list-unstyled">
                      {
                        group.menuItems.filter(link => get(link, 'footer') !== false).map(link => (
                          <li className="Footer_subMenuItem" key={link._id}>
                            <Link
                              className="Footer_menuLink"
                              name={link.route}
                            >
                              {link.text}
                            </Link>
                          </li>
                        ))
                      }
                    </ul>
                  </li>
                ))
              }
            </ul>
          </nav>
        </div>
      </div>
      <div className="FooterBottom">
        <div className="container">
          <div className="Copyright">&copy;{(new Date().getFullYear())} {get(builder, 'name')}.All Rights Reserved.</div>
          <img className="Footer_EHOLogo"src="/images/equal-housing.png" alt="Equal Opportunity Housing" />
          <div className="SiteBy">Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a></div>
          <ul className="Footer_socialLinks">
            {
              get(builder, 'socialLinks', []).map(link => (
                <li key={link}>
                  <SocialLink
                    url={link}
                  />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
      <OSCTagMobile agent={agent} builder={builder} />
    </footer>
  );
}

Footer.propTypes = {
  agent: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};


export default withData(
  {
    agents: true,
    builder: true,
    agent: true,
  },
  {
    required: {
      builder: true,
    },
  },
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js